import React, { Component } from 'react';
import CodeInput from './CodeInput';
import './App.css';
import albumCover from './album_cover.jpg';

class App extends Component {
	render() {
		return (
			<div className="App">
				<div className="album_info">
					<div className="album">
						<img src={albumCover} alt="Troubleshooting by all boy/all girl" />
						<div className="audio__label">1. Troubleshooting</div>
						<audio controls="controls">
							<source src="/01_Troubleshooting.mp3" type="audio/mp3" />
						</audio>
					</div>
					<div className="info">
						<h2 className="info__title">Troubleshooting</h2>
						<h4 className="info__band">all boy/all girl</h4>
						<ol className="tracklist">
							<li>Troubleshooting</li>
							<li>Pacify</li>
							<li>Swimming</li>
							<li>Black</li>
							<li>Darling Darwin</li>
						</ol>
						<p className="credits">
							Recorded at Cash for Gold Studios in New York, NY<br/>
							Additional recording at Lake Lorraine in Elabell, GA<br/>
							Written and recorded by Nicholas Rahn<br/>
							All songs performed by Nicholas Rahn and Danielle Lovier<br/>
							and<br/>
							Susan Mandel: Cello (1 & 5)<br/>
							Midori Witkoski : Viola (1 & 5)<br/>
							Nicholas Handahl: Flute (1 & 5)<br/>
							Joey Campanella: Drums (5)<br/>
							Mastered by Gary Hobish
						</p>
						<CodeInput />
					</div>
				</div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js